import Route from 'react-router/lib/Route'
import IndexRedirect from 'react-router/lib/IndexRedirect'

import { loadableCreator } from '../delivery/loading/loadable-creator'
import { isMasterUser } from '../users-and-branches/duck/selectors'

const LoadableDeveloperDashboard = loadableCreator({
  dynamicImport: () =>
    import(
      /* webpackChunkName: 'developer-dashboard' */ './developer-dashboard.component'
    ),
  componentName: 'DeveloperDashboard',
})

const redirectToIndex = (store) => (
  _nextState,
  replace,
  callback
) => {
  const state = store.getState()
  const shouldRedirect = !isMasterUser(state)

  if (shouldRedirect) {
    replace('/')
  }
  callback()
}

const DeveloperRoutes = store => (
  <Route path="/developer">
    <IndexRedirect to="/developer/dashboard" />
    <Route
      path="dashboard"
      component={LoadableDeveloperDashboard}
      onEnter={redirectToIndex(store)}
    />
  </Route>
)

export { DeveloperRoutes }
